import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import DoneItemsList from '../components/DoneItemsList';
import { editTimeLeft, formatTimeLeftSimple } from 'lib/dateDisplay';

class RightSide extends React.Component {
  render() {
    const { formValues, fmString } = this.context;
    const { ids, startEdit, startView } = this.props;

    const finished = path(['rehab1', 'finished'], formValues);
    const canUpdate = !finished || editTimeLeft(finished);
    const filled = Object.keys(ids);
    const mappedItems = filled.map(type => ({
      locale:
        ids[type] && canUpdate
          ? `onlineRehabilitation.rehab1.updateBox.${type}`
          : `onlineRehabilitation.rehab1.box.${type}`,
      notStarted: !ids[type],
      canUpdate,
      updateAction: !ids[type] ? null : canUpdate ? () => startEdit(ids[type]) : null,
      viewAction: !ids[type] ? null : !canUpdate ? () => startView(ids[type], type) : null,
    }));
    return (
      <div>
        <DoneItemsList itemList={mappedItems} />
        <h3 style={{ fontSize: '1.3rem' }}>
          {canUpdate && finished && (
            <div>
              <div>{fmString('onlineRehabilitation.timeLeftEditing')}:</div>
              <div>
                {fmString('onlineRehabilitation.hrsMins', {
                  hrs: formatTimeLeftSimple(finished) ? formatTimeLeftSimple(finished).hrs : '',
                  mins: formatTimeLeftSimple(finished) ? formatTimeLeftSimple(finished).mins : '',
                })}
              </div>
            </div>
          )}
        </h3>
      </div>
    );
  }
}

RightSide.contextTypes = {
  formValues: object,
  fmString: func,
};
RightSide.propTypes = {
  ids: object,
  startEdit: func,
  startView: func,
};

export default RightSide;
